/* ely-sections.js: the campaign slideshow ([data-ely-hero], sections/ely-hero.liquid).
   Slides move sideways; dots and round arrows choose a slide; arrow keys work
   when the slideshow has focus; autoplay pauses on hover, on focus, when the
   tab is hidden and when the visitor prefers reduced motion.
   Theme editor: re-initialises on section load and jumps to a selected block. */
(function () {
  if (window.ElyHero) return;

  function Hero(root) {
    this.root = root;
    this.track = root.querySelector('[data-ely-track]');
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-ely-slide]'));
    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-ely-dot]'));
    this.index = 0;
    this.timer = 0;
    this.paused = false;
    this.reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.delay = (Number(root.getAttribute('data-speed')) || 7) * 1000;
    this.autoplay = root.getAttribute('data-autoplay') === 'true' && !this.reduce && this.slides.length > 1;
    var self = this;

    var prev = root.querySelector('[data-ely-prev]');
    var next = root.querySelector('[data-ely-next]');
    if (prev) prev.addEventListener('click', function () { self.go(self.index - 1); self.restart(); });
    if (next) next.addEventListener('click', function () { self.go(self.index + 1); self.restart(); });
    this.dots.forEach(function (d) {
      d.addEventListener('click', function () { self.go(Number(d.getAttribute('data-ely-dot'))); self.restart(); });
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { self.go(self.index - 1); self.restart(); }
      if (e.key === 'ArrowRight') { self.go(self.index + 1); self.restart(); }
    });
    root.addEventListener('mouseenter', function () { self.paused = true; });
    root.addEventListener('mouseleave', function () { self.paused = false; });
    root.addEventListener('focusin', function () { self.paused = true; });
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) self.paused = false; });

    /* swipe */
    var x0 = null;
    this.track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    this.track.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { self.go(self.index + (dx < 0 ? 1 : -1)); self.restart(); }
      x0 = null;
    });

    this.go(0, true);
    this.restart();
  }

  Hero.prototype.go = function (i, instant) {
    var n = this.slides.length;
    if (!n) return;
    this.index = (i + n) % n;
    if (instant) this.track.style.transition = 'none';
    this.track.style.transform = 'translateX(' + (-100 * this.index) + '%)';
    if (instant) { void this.track.offsetWidth; this.track.style.transition = ''; }
    var self = this;
    this.slides.forEach(function (s, k) {
      var on = k === self.index;
      if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
      s.querySelectorAll('[data-ely-focusable]').forEach(function (a) { a.tabIndex = on ? 0 : -1; });
    });
    this.dots.forEach(function (d, k) {
      if (k === self.index) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
    });
  };

  Hero.prototype.restart = function () {
    clearInterval(this.timer);
    if (!this.autoplay) return;
    var self = this;
    this.timer = setInterval(function () {
      if (!self.paused && !document.hidden) self.go(self.index + 1);
    }, this.delay);
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-ely-hero]').forEach(function (el) {
      if (el.__ely) clearInterval(el.__ely.timer);
      el.__ely = new Hero(el);
    });
  }

  window.ElyHero = { init: init };
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest && e.target.closest('[data-ely-slide]');
    var root = slide && slide.closest('[data-ely-hero]');
    if (!root || !root.__ely) return;
    root.__ely.paused = true;
    root.__ely.go(root.__ely.slides.indexOf(slide));
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var root = e.target.closest && e.target.closest('[data-ely-hero]');
    if (root && root.__ely) root.__ely.paused = false;
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
})();

/* Product page sticky bar ([data-ely-sticky], sections/ely-main-product.liquid).
   Shows once the main Add to bag button has scrolled out of view; its button
   submits the main product form, and its price mirrors the main price as the
   variant changes. */
(function () {
  if (window.ElySticky) return;

  function initSticky(sec) {
    var bar = sec.querySelector('[data-ely-sticky]');
    var buy = sec.querySelector('[data-ely-buy]');
    if (!bar || !buy || !('IntersectionObserver' in window)) return;
    var btn = bar.querySelector('[data-ely-sticky-btn]');
    var mainBtn = buy.querySelector('[data-msc-buy]');
    var mainLabel = buy.querySelector('[data-msc-buy-label]');
    var price = sec.querySelector('[data-msc-price]');
    var stickyPrice = bar.querySelector('[data-ely-sticky-price]');

    function show(on) {
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (btn) btn.tabIndex = on ? 0 : -1;
    }
    var past = false;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        past = !en.isIntersecting && en.boundingClientRect.top < 0;
        show(past);
      });
    }).observe(buy);

    function mirror() {
      if (price && stickyPrice) stickyPrice.innerHTML = price.innerHTML;
      if (btn && mainBtn) {
        btn.disabled = mainBtn.disabled;
        if (mainLabel) btn.textContent = mainLabel.textContent;
      }
    }
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(mirror);
      if (price) mo.observe(price, { childList: true, subtree: true, characterData: true });
      if (mainBtn) mo.observe(mainBtn, { attributes: true, childList: true, subtree: true, characterData: true });
    }
    mirror();

    if (btn) btn.addEventListener('click', function () {
      var form = buy.querySelector('form');
      if (!form || (mainBtn && mainBtn.disabled)) return;
      if (form.requestSubmit) form.requestSubmit(mainBtn || undefined);
      else if (mainBtn) mainBtn.click();
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-msc-pdp]').forEach(function (s) {
      if (!s.__elySticky) { s.__elySticky = 1; initSticky(s); }
    });
  }
  window.ElySticky = { init: boot };
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
})();

/* Delivery estimate ([data-ely-eta], the delivery note block in
   sections/ely-main-product.liquid). Finds the shopper's country (Shopify's
   browsing context suggestion, then the storefront country), then works in UK
   time: orders on a working day before the cut off hour go out that day,
   otherwise the next working day. Delivery adds working days by region: UK,
   Europe or the rest of the world. Weekends and England bank holidays are
   skipped. UK shoppers before the cut off also see a countdown. */
(function () {
  if (window.ElyEta) return;

  var EUROPE = 'AD AL AT AX BA BE BG BY CH CY CZ DE DK EE ES FI FO FR GG GI GR HR HU IE IM IS IT JE LI LT LU LV MC MD ME MK MT NL NO PL PT RO RS SE SI SJ SK SM UA VA XK'.split(' ');
  var HOLIDAYS = [
    '2026-01-01', '2026-04-03', '2026-04-06', '2026-05-04', '2026-05-25', '2026-08-31', '2026-12-25', '2026-12-28',
    '2027-01-01', '2027-03-26', '2027-03-29', '2027-05-03', '2027-05-31', '2027-08-30', '2027-12-27', '2027-12-28',
    '2028-01-03', '2028-04-14', '2028-04-17', '2028-05-01', '2028-05-29', '2028-08-28', '2028-12-25', '2028-12-26'
  ];

  function ukNow() {
    var parts = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    return {
      date: new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day, 12)),
      mins: (+parts.hour % 24) * 60 + (+parts.minute)
    };
  }
  function iso(d) { return d.toISOString().slice(0, 10); }
  function working(d) { var w = d.getUTCDay(); return w !== 0 && w !== 6 && HOLIDAYS.indexOf(iso(d)) < 0; }
  function addDay(d) { return new Date(d.getTime() + 864e5); }
  function addWorking(d, n) { while (n > 0) { d = addDay(d); if (working(d)) n--; } return d; }
  function nextWorking(d) { d = addDay(d); while (!working(d)) d = addDay(d); return d; }
  function fmt(d) {
    return new Intl.DateTimeFormat('en-GB', { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long' }).format(d);
  }
  function plural(n, w) { return n + ' ' + w + (n === 1 ? '' : 's'); }

  function region(cc) {
    cc = String(cc || '').toUpperCase();
    if (cc === 'GB' || cc === 'UK') return 'uk';
    return EUROPE.indexOf(cc) > -1 ? 'eu' : 'world';
  }

  function country(fallback) {
    var key = 'ely-eta-cc';
    try { var c = sessionStorage.getItem(key); if (c) return Promise.resolve(c); } catch (e) {}
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + 'browsing_context_suggestions.json', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var cc = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
        cc = cc || fallback || 'GB';
        try { sessionStorage.setItem(key, cc); } catch (e) {}
        return cc;
      })
      .catch(function () { return fallback || 'GB'; });
  }

  function render(el, cc) {
    var cutoff = (parseInt(el.getAttribute('data-cutoff'), 10) || 14) * 60;
    var reg = region(cc);
    var range = (el.getAttribute('data-' + reg) || '').split(',').map(function (n) { return parseInt(n, 10); });
    var most = range[range.length - 1] || (reg === 'uk' ? 1 : reg === 'eu' ? 6 : 15);
    var now = ukNow();
    var sameDay = working(now.date) && now.mins < cutoff;
    var dispatch = sameDay ? now.date : nextWorking(now.date);
    var by = addWorking(dispatch, most);
    var html = '';
    if (reg === 'uk' && sameDay) {
      var left = cutoff - now.mins;
      var h = Math.floor(left / 60), m = left % 60;
      var wait = h ? plural(h, 'hr') + (m ? ' ' + plural(m, 'min') : '') : plural(Math.max(m, 1), 'min');
      html = 'Order within ' + wait + ' to get it by <strong>' + fmt(by) + '</strong>';
    } else {
      html = 'Get it by <strong>' + fmt(by) + '</strong>';
    }
    el.innerHTML = html;
    el.hidden = false;
  }

  function init(el) {
    if (el.__elyEta) return;
    el.__elyEta = 1;
    country(el.getAttribute('data-country')).then(function (cc) {
      render(el, cc);
      setInterval(function () { render(el, cc); }, 60000);
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-ely-eta]').forEach(init);
  }
  window.ElyEta = { init: boot };
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
})();

/* Cart upsell ([data-ely-upsell], snippets/ely-cart-upsell.liquid). The drawer
   re-renders its HTML after every change, so everything here is delegated.
   Arrows step the carousel; Add posts to /cart/add.js and hands the sections
   back to Dawn's cart drawer so the bag (and this carousel) refresh. */
(function () {
  if (window.ElyUpsell) return;
  window.ElyUpsell = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ely-upsell-step]');
    if (!b) return;
    var track = b.closest('[data-ely-upsell]').querySelector('[data-ely-upsell-track]');
    var card = track && track.firstElementChild;
    if (!card) return;
    var step = card.getBoundingClientRect().width + 8;
    track.scrollBy({ left: step * parseInt(b.getAttribute('data-ely-upsell-step'), 10), behavior: 'smooth' });
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-ely-upsell-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    if (btn && btn.getAttribute('aria-busy') === 'true') return;
    var id = Number(form.querySelector('[name="id"]').value);
    var drawer = document.querySelector('cart-drawer');
    var items = [{ id: id, quantity: 1 }];
    /* product page: add the product being viewed too (its chosen variant),
       unless that variant is already in the bag */
    var mainInput = form.hasAttribute('data-ely-upsell-with-main') &&
      document.querySelector('[data-msc-pdp] .msc-pdp__form input[name="id"]');
    var mainId = mainInput ? Number(mainInput.value) : 0;
    var mainBtn = document.querySelector('[data-msc-pdp] [data-msc-buy]');
    if (mainBtn && mainBtn.disabled) mainId = 0;
    if (btn) btn.setAttribute('aria-busy', 'true');
    var ready = mainId
      ? fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          var inBag = cart.items.some(function (it) { return it.variant_id === mainId; });
          if (!inBag) items.unshift({ id: mainId, quantity: 1 });
        }).catch(function () { items.unshift({ id: mainId, quantity: 1 }); })
      : Promise.resolve();
    ready.then(function () {
    var body = { items: items };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (btn) btn.removeAttribute('aria-busy');
        if (!res.ok) { if (btn) btn.textContent = 'Sold out'; return; }
        fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          document.dispatchEvent(new CustomEvent('msc:cart-updated', { detail: { itemCount: cart.item_count } }));
        }).catch(function () {});
        if (drawer && drawer.renderContents && res.json.sections) {
          var state = res.json; state.id = id;
          drawer.renderContents(state);
        } else {
          window.location.href = root + 'cart';
        }
      })
    }).catch(function () { if (btn) btn.removeAttribute('aria-busy'); form.submit(); });
  });
})();
